import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { ImageCarousel } from "@faire/retailer-visitor-shared/components/ImageCarousel/ImageCarousel";
import { TrackedLink } from "@faire/retailer-visitor-shared/components/TrackedLink/index";
import { TransparencyOverlay } from "@faire/web--source/ui/TransparencyOverlay";
import { trackBrandTileClickBrandTileImageScrollClick } from "@faire/web-api--source/events/brandTile/click/clickBrandTileImageScroll";
import { observer } from "mobx-react";
import React, { useCallback } from "react";
var BrandTileImageSectionBase = function(param) {
    var title = param.title, pageType = param.pageType, images = param.images, onLinkClick = param.onLinkClick, linkLocation = param.linkLocation, token = param.token, name = param.name;
    var imageWrapper = useCallback(function(p) {
        return /*#__PURE__*/ _jsx(TrackedLink, _object_spread_props(_object_spread({}, p), {
            token: token,
            onClick: function() {
                onLinkClick === null || onLinkClick === void 0 ? void 0 : onLinkClick();
            },
            to: linkLocation
        }));
    }, [
        token,
        onLinkClick,
        linkLocation
    ]);
    return /*#__PURE__*/ _jsx(ImageCarousel, {
        title: title,
        pageType: pageType,
        images: images,
        ImageWrapper: imageWrapper,
        name: name !== null && name !== void 0 ? name : "",
        hideDotsWhenSingleImage: true,
        otelSpanName: "BrandTileImage",
        onImageScrolled: function(index, action) {
            trackBrandTileClickBrandTileImageScrollClick(token !== null && token !== void 0 ? token : "", index.toString(), action);
        },
        children: /*#__PURE__*/ _jsx(TransparencyOverlay, {})
    });
};
export var BrandTileImageSection = observer(BrandTileImageSectionBase);
